import React from "react";
import { API_URL, API_HEADERS } from "../../../constants/api";
import ValidateOtp from "../ValidateOtp/ValidateOtp";
import { ShowToast, toastType } from "../../../utils/toast-service";
import { apiPost } from "../../../utils/api_service";
import { encodeEmail, validatePassword } from "../../../utils/generic";

class SignIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      view: "login",
      email: undefined,
      password: undefined,
      phoneNumber: null
    };
  }

  /**Authenticate External User and Tenant */
  authenticate = () => {
    const { email, password } = this.state;
    if (email == null || email == undefined || email == "") {
      ShowToast("Please enter username", toastType.ERROR, 5000, 200);
      return false;
    } else if (password == null || password == undefined) {
      ShowToast("Please enter password", toastType.ERROR, 5000, 200);
      return false;
    }
    if (validatePassword(password) == false) {
      ShowToast(
        "Password must be 8 to 12 alphanumeric characters and at-least one of the special characters in (!,@,#,$,%,^,&,*) ",
        toastType.ERROR,
        5000,
        200
      );
      return false;
    }

    const postBody = {
      email: email,
      password: password,
      otp: "string"
    };
    apiPost({
      url: API_URL.tenant.Authenticate,
      postBody: postBody
    }).then(response => {
      if (response.data.success == false) {
        let GetLoginAttempt;
        if (
          localStorage.getItem("LoginAttempt") == null ||
          isNaN(localStorage.getItem("LoginAttempt"))
        ) {
          localStorage.setItem("LoginAttempt", "0");
          GetLoginAttempt = 0;
        } else {
          GetLoginAttempt = localStorage.getItem("LoginAttempt");
        }

        GetLoginAttempt = parseInt(GetLoginAttempt) + 1;
        localStorage.setItem("LoginAttempt", parseInt(GetLoginAttempt));
        if (GetLoginAttempt > 3) {
          ShowToast(
            "You have exceeded login attempts. Please try resetting password.",
            toastType.ERROR,
            5000,
            200
          );
          const { resetPassword } = this.props;
          resetPassword("password");
          localStorage.setItem("LoginAttempt", 0);
        }

        ShowToast(response.data.message, toastType.ERROR, 5000, 200);
      } else if (response.data.success == true) {
        this.setState({ view: "otp", phoneNumber: response.data.data });
        ShowToast(response.data.message, toastType.SUCCESS, 5000, 200);
      }
    });
  };

  /**Verify OTP */
  verifyOTP = otp => {
    const { email, password } = this.state;

    const postBody = {
      email: email,
      password: password,
      otp: otp,
      type: "LOGIN"
    };
    apiPost({
      url: API_URL.tenant.VerifyOTP,
      postBody: postBody
    }).then(response => {
      if (response.data.success == false) {
        ShowToast(response.data.message, toastType.ERROR, 5000, 200);
      } else if (response.data.success == true) {
        ShowToast(response.data.message, toastType.SUCCESS, 5000, 200);
        localStorage.setItem(
          API_HEADERS.authToken,
          response.data.data.jwtToken
        );
        localStorage.setItem("DCTL", "/user");
        window.location = "/user";
      }
    });
  };

  /** Resend OTP */
  resendOTP = opt => {
    const { email, password } = this.state;
    const postBody = {
      email: email,
      password: password,
      otp: opt,
      type: "LOGIN"
    };
    apiPost({
      url: API_URL.tenant.ResendOTP,
      postBody: postBody
    }).then(response => {
      if (response.data.success == true) {
        ShowToast("OTP sent successfully", toastType.SUCCESS, 5000, 200);
      } else {
        ShowToast(
          "There is issue with sending OTP",
          toastType.SUCCESS,
          5000,
          200
        );
      }

      //console.log(response);
    });
  };

  /** Set values */
  setValues = (value, FieldName) => {
    if (FieldName == "Password") {
      this.setState({ password: value });
    } else {
      this.setState({ email: value });
    }
  };

  render() {
    const { view, email, phoneNumber } = this.state;
    const { resetPassword } = this.props;
    return (
      <>
        {view == "login" ? (
          <div>
            <div>
              <label>{"Username"}</label>
              <br />
              <input
                type={"text"}
                name={"User Name"}
                className={"text-field bg-login bgImgSet"}
                onBlur={event => {
                  this.setValues(event.target.value, "Email");
                }}
              />
            </div>
            <div>
              <label>{"Password"}</label>
              <br />
              <input
                type={"password"}
                name={"Password"}
                className={"text-field bg-password bgImgSet"}
                onPaste={() => {
                  return false;
                }}
                onBlur={event => {
                  event.target.value != ""
                    ? this.setValues(event.target.value, "Password")
                    : ShowToast(
                        "Please enter the password",
                        toastType.ERROR,
                        5000,
                        200
                      );
                }}
              />
            </div>
            <div className={"w-100"} style={{ paddingTop: "9px" }}>
              <span
                className={"pointer"}
                onClick={() => resetPassword("password")}
              >
                {"Forgot Password?\r"}
              </span>
            </div>
            <div className={"d-flex"} style={{ marginTop: "15px" }}>
              <div className={"w-30"}>
                <button
                  type={"button"}
                  className={"login-button"}
                  onClick={() => {
                    localStorage.removeItem("selectedPropertyIdMultiple");
                    localStorage.removeItem("selectedPropertyId");
                    localStorage.removeItem("selectedPropertyIdMultipleNames");
                    localStorage.removeItem("Abbreviation");
                    localStorage.removeItem("selectedstartDate");
                    localStorage.removeItem("selectedendDate");
                    localStorage.removeItem("DCLT");
                    localStorage.setItem("isUnAuthorized", false);
                    localStorage.setItem("isExternal", true);
                    localStorage.setItem("isExternalContractor", true);
                    localStorage.setItem("isApiCalled","false");
                    localStorage.removeItem("isReloadAttempt")
                    this.authenticate();
                  }}
                >
                  {"Log In\r"}
                </button>
              </div>
              <div className={"w-10"} style={{ paddingTop: "9px" }}>
                {"Or\r"}
              </div>
              <div className={"w-60"}>
                <button
                  type={"button"}
                  className={"login-button"}
                  onClick={() => {
                    localStorage.setItem("DCLT", "/dc-user");
                    localStorage.setItem("loggedInLog", true);
                    localStorage.setItem("isUnAuthorized", false);
                    localStorage.removeItem("selectedPropertyIdMultiple");
                    localStorage.removeItem("selectedPropertyId");
                    localStorage.removeItem("selectedPropertyIdMultipleNames");
                    localStorage.removeItem("Abbreviation");
                    localStorage.setItem("isExternal", false);
                    window.location = "/dc-user";
                    localStorage.setItem("isApiCalled","false");
                    localStorage.removeItem("isReloadAttempt")
                  }}
                >
                  {"Log In Using Stream Domain\r"}
                </button>
              </div>
            </div>
          </div>
        ) : (
          <ValidateOtp
            email={encodeEmail(email)}
            verifyOTP={this.verifyOTP}
            resendOTP={this.resendOTP}
            phoneNumber={phoneNumber}
          />
        )}
      </>
    );
  }
}

export default SignIn;
